export default "__VITE_ASSET__DIxQ7GBD__"